import * as React from "react";
import { CheckoutPage } from '../checkout-page.component';
import { useState, useEffect } from "react";
import { IReceiptPage } from "@montana/models/generated/cms.interface";
import { useCart } from "@montana/containers/cart";
import { useRouter } from "@montana/containers/router";
import { DynamicBlocks } from "@montana/blocks/dynamic-blocks.component";
import { useDynamicSettings } from "@montana/containers/dynamic-settings";

export const ReceiptPage: React.FC<IReceiptPage> = ({ blocks }: IReceiptPage): JSX.Element => {
    const [index, setIndex] = useState(1);
    const { push } = useRouter();
    const { links } = useDynamicSettings();
    const { placeOrderWasSuccess, resetOrderState } = useCart();

    useEffect(() => {
        if (!placeOrderWasSuccess) {
            resetOrderState();
            push(links?.homePage || '/');
            return;
        }
        setTimeout(() => setIndex(2), 100);

        return (): void => {
            resetOrderState();
        };
    }, [])

    return (
        <CheckoutPage progressBarIndex={index} progressBarAllowNavigationBack={false}>

            <DynamicBlocks blocks={blocks} />

        </CheckoutPage >
    );
};
